<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="86" height="86" viewBox="0 0 86 86" fill="none">
        <rect width="86" height="86" rx="43" fill="#EC4B1D" fill-opacity="0.31" />
        <path
            d="M46.3792 16H48.4427V21.5025H53.9452V23.566H48.4427V29.0685H46.3792V23.566H40.8767V21.5025H46.3792V16Z"
            fill="#EC4B1D"
        />
        <path
            d="M60.6706 31.2466H63.1926V37.9719H69.9179V40.4939H63.1926V47.2192H60.6706V40.4939H53.9453V37.9719H60.6706V31.2466Z"
            fill="#EC4B1D"
        />
        <path
            d="M27.4262 30.5205H28.9165V34.4946H32.8905V35.9848H28.9165V39.9589H27.4262V35.9848H23.4521V34.4946H27.4262V30.5205Z"
            fill="#EC4B1D"
        />
        <path
            d="M37.2848 32.6987H43.0166V47.9835H58.3014V53.7153H43.0166V69.0001H37.2848V53.7153H22V47.9835H37.2848V32.6987Z"
            fill="#EC4B1D"
        />
    </svg>
</template>
<script>
export default {
    name: "ExtraPlanIcon",
};
</script>
